import { FC } from 'react'
import { Button } from 'antd'
import { CheckOutlined, CloseOutlined, ArrowRightOutlined } from '@ant-design/icons'

interface RememberButtonsProps {
    notRememberState: boolean
    remember: () => void
    notRemember: () => void
    nextAndRotateWord: () => void
}

const RememberButtons: FC<RememberButtonsProps> = ({ remember, notRemember, notRememberState, nextAndRotateWord }) => {
    return (
        <div className='word-card__btn-area'>
            <Button
                type='primary'
                size='large'
                icon={<CheckOutlined />}
                disabled={notRememberState}
                onClick={remember}
            >
                Помню
            </Button>
            <Button
                size='large'
                danger={!notRememberState}
                icon={notRememberState ? <ArrowRightOutlined /> : <CloseOutlined />}
                onClick={notRememberState ? nextAndRotateWord : notRemember}
            >
                {notRememberState ? 'Следующее' : 'Не помню'}
            </Button>
        </div>
    )
}

export default RememberButtons
